import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
  application: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%'
  },
  applicationContent: {
    flex: 1
  },
  left: {
    '@media(max-width: 1024px)': {
      position: 'absolute'
    }
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100%'
  }
});
